<!-- Banner -->
<div class="banner transloading" *ngIf="privacyPage" [heroImage]="privacyPage.heroImageURL">
  <h1 class="banner-text">{{privacyPage.heroTitle}}</h1>
</div>

<!-- Breadcrumb Wrapper -->
<div class="breadcrumb-wrapper" *ngIf="privacyPage">
  <div class="row">
    <div class="col-md-10 col-xs-12 col-md-offset-1">
      <ol>
        <li routerLink="/home">
          <span class="material-icons">home</span>
        </li>
        <ng-container *ngFor="let breadcrumb of getBreadcrumbs(); let last = last">
          <li [ngClass]="{'child': !last, 'active': last}">
            {{ breadcrumb }}
          </li>
        </ng-container>
      </ol>
    </div>
  </div>
</div>

<!-- Section -->
<div class="content-section">
  <div class="row">
    <div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1" *ngIf="privacyPage">
      <h4 class="header-text text-blue py-2">
        {{privacyPage.heroTitle}}
      </h4>
    </div>
  </div>
  <div class="row" *ngIf="privacyPage">
        <div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1">
          <div class="content-text pt-0">
            <div class="content" [innerHTML]="sanitizedMasterSubHeader"></div>

            <div class="content">{{privacyPage.linkHeader}}</div>

            <ul class="remove-padding">
              <li><a [routerLink]="['/privacy-policy']" fragment="types-we-collect">{{privacyPage.linkHeaderTypesofPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="collection-of-personal-information">{{privacyPage.linkHeaderCollectionofPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="use-and-processing-of-personal-informaton">{{privacyPage.linkHeaderProcessingOfPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="disclosure-of-personal-information">{{privacyPage.linkHeaderDisclosureofPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="cookies-tracking-technology">{{privacyPage.linkHeaderTrackingTechnologies}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="your-right-choice">{{privacyPage.linkHeaderYourRightsandChoices}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="protect-personal-information">{{privacyPage.linkHeaderProtectPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="keep-personal-information">{{privacyPage.linkHeaderKeepYourPersonalInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']" fragment="other-important-information">{{privacyPage.linkHeaderImportantInformation}}</a></li>
              <li><a [routerLink]="['/privacy-policy']"
                  fragment="contact-information">{{privacyPage.linkHeaderContactInformation}}</a></li>
            </ul>

            <div class="content mt-5" id="types-we-collect">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderTypesofPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedTypesOfPersonalInfo"></p>

              <div class="table-responsive">
                <table class="table-bordered privacy-table">
                  <thead class="thead-light">
                    <tr class="table-secondary" *ngFor="let item of privacyPage?.tblHeaderPersonalInfo">
                      <th>
                        {{item.tblHeader1}}
                      </th>
                      <th>
                        {{item.tblHeader2}}
                      </th>
                      <th [innerHtml]="item.tblHeader3">

                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of privacyPage?.tableTypesOfPersonalInformation">
                      <td>
                        <p>{{item.Context}}</p>
                      </td>
                      <td>
                        <p>{{item.TypesofData}}</p>
                      </td>
                      <td>
                        <p>{{item.PrimaryPurpose}}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
 
            </div>

            <div class="content mt-5" id="collection-of-personal-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderCollectionofPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedCollectionOfPersonalInfo"></p>
            </div>


            <div class="content mt-5" id="use-and-processing-of-personal-informaton">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderProcessingOfPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedProcessingOfPersonalInfo"></p>
            </div>
 
            <div class="content mt-5" id="disclosure-of-personal-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderDisclosureofPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedDisclosureOfPersonalInfo"></p>
            </div>


            <div class="content mt-5" id="cookies-tracking-technology">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderTrackingTechnologies}}</h4>

              <p [innerHTML]="sanitizedTrackingTechnologies"></p>


              <div class="table-responsive">
                <table class="table-bordered privacy-table">
                  <thead class="thead-light">
                    <tr class="table-secondary" *ngFor="let item of privacyPage?.tblHeaderTrackingtechnology">
                      <th>
                        {{item.tblHeader1}}
                      </th>
                      <th>
                        {{item.tblHeader2}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of privacyPage?.tableTrackingTechnology">
                      <td>
                        <p>{{item.CookieType}}</p>
                      </td>
                      <td>
                         <p [innerHtml]="item.Description"></p>
                      </td>
                      
                    </tr>
                  </tbody>
                </table>
              </div>

              <p [innerHTML]="sanitizedSubTrackingTech"></p>

            </div>

            <div class="content mt-5" id="your-right-choice">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderYourRightsandChoices}}</h4>

              <p [innerHTML]="sanitizedRightsAndChoices"></p>
            </div>

            <div class="content mt-5" id="protect-personal-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderProtectPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedProtectPersonalInfo"></p>
            </div>

            <div class="content mt-5" id="keep-personal-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderKeepYourPersonalInformation}}</h4>

              <p [innerHTML]="sanitizedKeepPersonalInfo"></p>
            </div>

            <div class="content mt-5" id="other-important-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderImportantInformation}}</h4>

              <div [innerHTML]="sanitizedImportantInfo"></div>
            </div>

            <div class="content mt-5" id="contact-information">
              <h4 class="header-text text-blue py-2">{{privacyPage.linkHeaderContactInformation}}</h4>

              <div [innerHTML]="sanitizedContactInfo"></div>
            </div>


          </div>
        </div>
      </div>



</div>